import serviciosV2Client from "../../../helpers/serviciosV2Client"

/**
 * Detalle completo de una factura por CUFE.
 * Devuelve: cabecera, líneas (data), métodos_pago, cargos, correos, totales.
 */
export const getDetalleFactura = (cufe) =>
  serviciosV2Client.get(`facturas/${encodeURIComponent(cufe)}/detalles`)
